import { RouteObject } from 'react-router-dom'

import { default as SubscriptionVenues } from '.'
import { PageLayout } from '../../../common/app'

/**
 * Routes for the Manage Venues page - lists every venue on the subscription
 * and hosts the "Add a new venue" action.
 *
 * `htmlTitleOnly` suppresses the standard in-page header (which otherwise shows
 * the reports date filter that has no meaning here); the page renders its own
 * content in a centred, capped-width column matching My Profile / Manage
 * Billing.
 */
export const venuesRoutes: RouteObject[] = [
  {
    path: '/settings/billing/venues',
    element: (
      <PageLayout title="Manage Venues" htmlTitleOnly alignMainContent="center">
        <SubscriptionVenues.SubscriptionVenues.Component />
      </PageLayout>
    ),
    loader: SubscriptionVenues.SubscriptionVenues.Loader,
  },
]
